import { Badge } from "@/components/ui/badge";
import { ConvertStatusById } from "@/utils/convert-status-to-name/convert-status-to-name";
import { StatusBedgeProps } from "./status-bedge.types";

export const StatusBedge = ({ status, type }: StatusBedgeProps) => {
  const CURRENT_STATUS_BEDGE = ConvertStatusById({ status, type });

  return (
    <Badge variant={CURRENT_STATUS_BEDGE?.badge_color}>
      {CURRENT_STATUS_BEDGE?.title}
    </Badge>
  );
};
